<div class="agpr-footerActionBar agpr-footerActionBar-social">
    <div class="agpr-footerActionBar-leftButtons">
        <ng-container *ngFor="let button of leftButtonGroup; index as i">
            <agpr-button
                *ngIf="button?.visible"
                [id]="id + '.footerActionBar.leftButton_' + i"
                [label]="button.name"
                [style]="button.isOutline ? buttonStyle.secondary : buttonStyle.primaryB"
                [disabled]="button.disabled"
                (click)="clickEvent(button)"
            ></agpr-button>
        </ng-container>
    </div>
    <div class="agpr-footerActionBar-rightButtons">
        <ng-container *ngFor="let button of rightButtonGroup; index as i">
            <agpr-button
                *ngIf="button?.visible"
                [id]="id + '.footerActionBar.leftButton_' + i"
                [label]="button.name"
                [style]="button.isOutline ? buttonStyle.secondary : buttonStyle.primary"
                [disabled]="button.disabled"
                (click)="clickEvent(button)"
            ></agpr-button>
        </ng-container>
    </div>
</div>

